import {
    Selector as PropsSelector,
    Layout as PropsLayout,
} from '@/models/Props';
import { LFlexSystem } from '@/components/layouts';

import './Footer.scss';

const Footer = ({ ariaLabel, children }: PropsSelector & PropsLayout) => {
    return (
        <footer aria-label={ariaLabel}>
            <LFlexSystem
                className={'footer-icons'}
                sortChildren={'columns'}
                gap={2}
            >
                {children}
            </LFlexSystem>
        </footer>
    );
};

export default Footer;
